export const getScrollPercentage = (): number => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const scrollHeight = Math.max(
    document.documentElement.scrollHeight,
    document.body.scrollHeight
  )
  const clientHeight = document.documentElement.clientHeight
  const scrollableHeight = scrollHeight - clientHeight

  if (scrollableHeight === 0) {
    return 0
  }

  const scrollPercentage = (scrollTop / scrollableHeight) * 100
  return Math.round(scrollPercentage)
}

export const trackScrollValues = (
  scrollValues: number[],
  onScrollReached: (value: number) => void
): (() => void) => {
  const scrollReached: number[] = []

  const handleScroll = (): void => {
    const scrollPercentage = getScrollPercentage()
    const roundedScrollPercentage = Math.round(scrollPercentage)

    for (let i = 0; i < scrollValues.length; i++) {
      const value = scrollValues[i]

      if (roundedScrollPercentage >= value && !scrollReached.includes(value)) {
        scrollReached.push(value)
        onScrollReached(value)
      }
    }
  }

  window.addEventListener('scroll', handleScroll)

  return (): void => {
    window.removeEventListener('scroll', handleScroll)
  }
}

export function scrollPageStop(condition: boolean): void {
  const isVisible = condition ? 'hidden' : 'visible'

  document.body.style.overflow = isVisible
  document.documentElement.style.overflow = isVisible
}
